import type { ClientEvent, ClientEventKind, ClientScreen } from "../api/types";

/**
 * Аналитика воронки: страница → пилот → пейвол → оплата → серии. Только вид события,
 * номер серии и экран — никакого текста (ARCHITECTURE §4.6). Отправка — через API, куда
 * выставит main.tsx до первого рендера.
 */

type Sink = (event: ClientEvent) => void;

export interface EventDetails {
  episode?: number | undefined;
  screen?: ClientScreen | undefined;
}

let sink: Sink | null = null;
const once = new Set<string>();

export function setAnalyticsSink(next: Sink | null): void {
  sink = next;
}

/** Событие без пустых полей: контракт не ждёт episode: undefined. */
export function buildEvent(kind: ClientEventKind, details: EventDetails = {}): ClientEvent {
  return {
    kind,
    ...(details.episode !== undefined ? { episode: details.episode } : {}),
    ...(details.screen !== undefined ? { screen: details.screen } : {}),
  };
}

export function track(kind: ClientEventKind, details: EventDetails = {}): void {
  sink?.(buildEvent(kind, details));
}

/**
 * Событие один раз за загрузку страницы по ключу. StrictMode в разработке вызывает
 * эффекты дважды, а «начал серию» дважды — это уже ложь в воронке.
 */
export function trackOnce(key: string, kind: ClientEventKind, details: EventDetails = {}): void {
  if (once.has(key)) return;
  once.add(key);
  track(kind, details);
}
